<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :title="'다이렉트 메시지'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="margin-top: 16px; padding: 0 12px; flex: 1; overflow-y: scroll;">
            <div style="font-weight: 500; font-size: 20px; line-height: 24px;">{{ messageInfo.from_member.nic_name }}님에게<br>훈련 영상 피드백 보내기</div>
            <div style="display: flex; gap: 8px; align-items: center; margin-top: 20px;">
                <div>
                    <ProfileImage style="width: 60px" :image-path="messageInfo.from_member.image_path"></ProfileImage>
                </div>
                <div>
                    <div style="font-weight: 700; font-size: 14px; margin-bottom: 4px;">{{ messageInfo.from_member.nic_name }} <span style="font-weight: 700; color: var(--color-main);">{{ messageInfo.from_member.position }}</span></div>
                    <div style="display: flex; align-items: center; gap: 4px; font-weight: 500; font-size: 12px; line-height: 16px; color: #808080;">
                        {{ messageInfo.from_member && messageInfo.from_member.place ? messageInfo.from_member.place.name : ''}}
                        <span style="display: inline-block; width: 2px; height: 2px; border-radius: 50%; background: #808080;"></span>
                        {{ messageInfo.insert_date | agoDateStr }}
                    </div>
                </div>
            </div>
            <div style="margin-top: 8px; background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); border-radius: 12px; padding: 12px;">
                <CommonPost :preventClick="true" :isChat="true" :isDetail="true" :soccerHows="messageInfo.soccerhow"></CommonPost>
            </div>
            <div style="margin-top: 20px;">
                <div style="font-size: 14px; font-weight: 700; line-height: 24px;">따뜻한 피드백을 남겨주세요.</div>
                <div style="font-size: 12px; font-weight: 500; line-height: 20px;">감독/코치님의 한마디가 선수에게 기회가 될지도 몰라요 ✨</div>
                <textarea :placeholder="placeholder" v-model="contents" style="border: none; outline: none; resize: none; border-radius: 12px; margin-top: 8px; padding: 12px; line-height: 24px; width: 100%; height: 111px; background: #EEEEEE;" name="" id=""></textarea>
            </div>
        </div>
        <div style="padding: 0 12px; margin-bottom: 40px; padding-top: 12px;">
            <div @click="beforeCompleteAction" style="height: 56px; line-height: 56px; border-radius: 50px; background-color: var(--color-main); text-align: center; font-weight: 700; font-size: 14px;">훈련 피드백 보내기</div>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import ProfileImage from '@/components/common/ProfileImage'
import CommonPost from '@/components/soccerhowmain/CommonPost'
import { MAIN_TYPE } from '@/Constants'

export default {
    name: 'SendTrainingFeedback',
    components: { MercenaryHeader, ProfileImage, CommonPost },
    props: {
        messageInfo: {
            type: Object,
            default: () => { }
        },
        soccerhowIdx: {
            type: [Number, String],
            default: -1
        },
        main_type: {
            type: String,
            defualt: ''
        },
        soccerhow: {
            type: Object,
            default: () => { }
        },
        completeAction: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            contents: '',
            MAIN_TYPE: MAIN_TYPE,
            cur_modal_length: -1,
            placeholder: '예시)\n안녕하세요, 사커하우FC 감독입니다 😎\n실력 좋네요. 하체 힘만 더 키우면 바로 계약서 써야겠어요 ✍️'
        }
    },
    beforeDestroy() {
        window.visualViewport.removeEventListener('resize', this.detectResize);
    },
    mounted() {
        window.visualViewport.addEventListener("resize", this.detectResize);
    },
    created() {
        this.cur_modal_length = this.$GlobalStore.getModalLength();
    },
    methods: {
        detectResize() {
            if (window.visualViewport.offsetTop === 0) {
                if (this.$cookies.get('device') === 'ios') {
                    this.$GlobalStore.unsetLastModalFixedInIOS(this.cur_modal_length - 1);
                }
            } else {
                if (this.$cookies.get('device') === 'ios') {
                    this.$GlobalStore.setLastModalFixedInIOS(window.visualViewport.offsetTop, window.visualViewport.height);
                }
            }
        },
        beforeCompleteAction() {
            if (this.contents.length < 5) {
                alert('5자 이상 입력해주세요.')
                return
            }
            this.completeAction(true, this.messageInfo.idx, this.contents)
        },
        
    }
}
</script>

<style scoped>
textarea::placeholder {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: #bbbbbb;
}
</style>